export const NavigationData: any = [
  { name: 'POČETNA', link: '/' },
  // { name: 'AGENDA', link: '/agenda' },
  // { name: 'UČESNICI', link: '/participants' },
  // { name: 'SMEŠTAJ', link: '/accommodation' },
  // { name: 'SPONZORI', link: '/sponsors' },
  { name: 'ARHIVA', link: '/archive' }
];
